import Auth from './components/Auth';

export default Auth;
